// extracted by mini-css-extract-plugin
export default {"setting":"setting__vajeHRCu","label":"label__yXwYQLOH","withTooltip":"with-tooltip__ufUtbr4u","entry":"entry__BSXnn3Pr"};